import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SvgIcon } from "../Icon/SvgIcon";
export var RatingStarAppearance;
(function(RatingStarAppearance) {
    RatingStarAppearance["Full"] = "full";
    RatingStarAppearance["Half"] = "half";
    RatingStarAppearance["Empty"] = "empty";
})(RatingStarAppearance || (RatingStarAppearance = {}));
var RatingStar = function(_param) {
    var _appearence = _param.appearence, appearence = _appearence === void 0 ? RatingStarAppearance.Empty : _appearence, props = _object_without_properties(_param, [
        "appearence"
    ]);
    switch(appearence){
        case RatingStarAppearance.Empty:
            {
                return /*#__PURE__*/ _jsx(SvgIcon, _object_spread({
                    name: "starEmpty"
                }, props));
            }
        case RatingStarAppearance.Full:
            {
                return /*#__PURE__*/ _jsx(SvgIcon, _object_spread({
                    name: "starFull"
                }, props));
            }
        case RatingStarAppearance.Half:
            {
                return /*#__PURE__*/ _jsx(SvgIcon, _object_spread({
                    name: "starHalf"
                }, props));
            }
        default:
    }
    return null;
};
export { RatingStar };
